import Vue from 'vue';
import routerPageHook from '@assets/js/routerPageHook.js'
import Card from '@components/ui-components/card/component.js';
import Banner from '@components/ui-components/banner/component.js';
import tagsBlock from '@components/ui-components/tags/tags.vue';
import Quote from '@components/ui-components/quote/component.js';
import SliderView from '@components/ui-components/slider-view/component.js';
import { mapState } from "vuex";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',

        }
    },
    components: {
        'card-cmp': Card,
        'banner-cmp': Banner,
        'quote-cmp': Quote,
        'tags-cmp': tagsBlock,
        'slider-view-cmp': SliderView,
    },
    computed: {
        ...mapState('mobile', ['isMobile', 'isTablet']),
    },
    methods: {
        getName(name) {
            let mass = name.split(' ');
            mass = mass.filter((item, index) => index < 2);
            let result = '';
            mass.forEach((item) => {
                result = result + item.split('')[0];
            });
            return result;
        }
    },
    ...routerPageHook,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/news/view/index.js